import { BaseRepository } from '../../infra/base.repository'
import { ConfigService } from '../../infra/config'
import type { BillEntity } from './bill'
import type { PayBillDto } from './dto/pay-bill.dto'

export class BillsRepository extends BaseRepository<BillEntity> {
    constructor(
        private config: ConfigService = new ConfigService(),
        token?: string,
        cache?: any,
    ) {
        super(config.financialApiUrl + '/bills', token, cache)
    }

    async pay(billId: string, dto: PayBillDto) {
        const { json, statusCode, message } = await this.request.post(
            this.config.financialApiUrl + '/bills/' + billId + '/pay?token=' + this.resolvedToken,
            dto,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }

    async void(billId: string) {
        const { json, statusCode, message } = await this.request.get(
            this.config.financialApiUrl + '/bills/' + billId + '/void?token=' + this.resolvedToken,
        )
        if (String(statusCode).substring(0, 1) === '2') return json
        throw message
    }
}
